/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Provide the sites for your app. Each site includes site id, and its localization configuration.
// You can also provide aliases for your locale. They will be used in place of your locale id when generating paths across the app
module.exports = [
    {
        id: 'bc-eu',
        l10n: {
            supportedCurrencies: ['EUR', 'GBP'],
            defaultCurrency: 'EUR',
            defaultLocale: 'it-IT',
            supportedLocales: [
                {
                    id: 'en-AT',
                    alias: 'en-at',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'de-AT',
                    alias: 'de-at',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AT',
                    alias: 'it-at',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-BE',
                    alias: 'en-be',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-BE',
                    alias: 'fr-be',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-BE',
                    alias: 'it-be',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-BG',
                    alias: 'en-bg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-BG',
                    alias: 'it-bg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-HR',
                    alias: 'en-hr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-HR',
                    alias: 'it-hr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-CY',
                    alias: 'en-cy',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-CY',
                    alias: 'it-cy',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-CZ',
                    alias: 'en-cz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-CZ',
                    alias: 'it-cz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-DK',
                    alias: 'en-dk',
                    preferredCurrency: 'DKK',
                },
                {
                    id: 'it-DK',
                    alias: 'it-dk',
                    preferredCurrency: 'DKK',
                },
                {
                    id: 'en-EE',
                    alias: 'en-ee',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-EE',
                    alias: 'it-ee',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-FI',
                    alias: 'en-fi',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-FI',
                    alias: 'it-fi',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-FR',
                    alias: 'en-fr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-FR',
                    alias: 'fr-fr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-FR',
                    alias: 'it-fr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-DE',
                    alias: 'en-de',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'de-DE',
                    alias: 'de-de',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-DE',
                    alias: 'it-de',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GR',
                    alias: 'en-gr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-GR',
                    alias: 'it-gr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-HU',
                    alias: 'en-hu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-HU',
                    alias: 'it-hu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-IE',
                    alias: 'en-ie',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-IE',
                    alias: 'it-ie',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-IT',
                    alias: 'en-it',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-IT',
                    alias: 'it-it',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-LV',
                    alias: 'en-lv',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-LV',
                    alias: 'it-lv',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-LT',
                    alias: 'en-lt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-LT',
                    alias: 'it-lt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-LU',
                    alias: 'en-lu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-LU',
                    alias: 'fr-lu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-LU',
                    alias: 'it-lu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-MT',
                    alias: 'en-mt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-MT',
                    alias: 'it-mt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-MC',
                    alias: 'en-mc',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-MC',
                    alias: 'it-mc',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-MC',
                    alias: 'fr-mc',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-NL',
                    alias: 'en-nl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-NL',
                    alias: 'it-nl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-PL',
                    alias: 'en-pl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-PL',
                    alias: 'it-pl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-PT',
                    alias: 'en-pt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-PT',
                    alias: 'it-pt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-RO',
                    alias: 'en-ro',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-RO',
                    alias: 'it-ro',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SK',
                    alias: 'it-sk',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SK',
                    alias: 'en-sk',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SI',
                    alias: 'it-si',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SI',
                    alias: 'en-si',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-ES',
                    alias: 'en-es',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-ES',
                    alias: 'it-es',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'es-ES',
                    alias: 'es-es',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SE',
                    alias: 'en-se',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SE',
                    alias: 'it-se',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-UA',
                    alias: 'en-ua',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-UA',
                    alias: 'it-ua',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GB',
                    alias: 'en-gb',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-GB',
                    alias: 'it-gb',
                    preferredCurrency: 'GBP',
                },
            ],
        },
    },
    {
        id: 'bc-cn',
        l10n: {
            supportedCurrencies: ['CNY'],
            defaultCurrency: 'CNY',
            defaultLocale: 'zh-CN',
            supportedLocales: [
                {
                    id: 'zh-CN',
                    alias: 'zh-cn',
                    preferredCurrency: 'CNY',
                },
                {
                    id: 'it-CN',
                    alias: 'it-cn',
                    preferredCurrency: 'CNY',
                },
                {
                    id: 'en-CN',
                    alias: 'en-cn',
                    preferredCurrency: 'CNY',
                },
            ],
        },
    },
    {
        id: 'bc-ca',
        l10n: {
            supportedCurrencies: ['CAD'],
            defaultCurrency: 'CAD',
            defaultLocale: 'en-CA',
            supportedLocales: [
                {
                    id: 'en-CA',
                    alias: 'en-ca',
                    preferredCurrency: 'CAD',
                },
                {
                    id: 'it-CA',
                    alias: 'it-ca',
                    preferredCurrency: 'CAD',
                },
                {
                    id: 'fr-CA',
                    alias: 'fr-ca',
                    preferredCurrency: 'CAD',
                },
            ],
        },
    },
    {
        id: 'bc-us',
        l10n: {
            supportedCurrencies: ['USD'],
            defaultCurrency: 'USD',
            defaultLocale: 'en-US',
            supportedLocales: [
                {
                    id: 'en-US',
                    alias: 'en-us',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-US',
                    alias: 'it-us',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-US',
                    alias: 'es-us',
                    preferredCurrency: 'USD',
                },
            ],
        },
    },
    {
        id: 'bc-apac',
        l10n: {
            supportedCurrencies: ['USD', 'HKD', 'JPY', 'KRW', 'SGD'],
            defaultCurrency: 'JPY',
            defaultLocale: 'en-JP',
            supportedLocales: [
                {
                    id: 'zh-HK',
                    alias: 'zh-hk',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'en-HK',
                    alias: 'en-hk',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'it-HK',
                    alias: 'it-hk',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'ja-HK',
                    alias: 'ja-hk',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'zh-MO',
                    alias: 'zh-mo',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'en-MO',
                    alias: 'en-mo',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'it-MO',
                    alias: 'it-mo',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'it-SG',
                    alias: 'it-sg',
                    preferredCurrency: 'SGD',
                },
                {
                    id: 'zh-SG',
                    alias: 'zh-sg',
                    preferredCurrency: 'SGD',
                },
                {
                    id: 'en-SG',
                    alias: 'en-sg',
                    preferredCurrency: 'SGD',
                },
                {
                    id: 'ja-SG',
                    alias: 'ja-sg',
                    preferredCurrency: 'SGD',
                },
                {
                    id: 'it-TW',
                    alias: 'it-tw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'zh-TW',
                    alias: 'zh-tw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-TW',
                    alias: 'en-tw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-KH',
                    alias: 'it-kh',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-KH',
                    alias: 'en-kh',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-IN',
                    alias: 'it-in',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-IN',
                    alias: 'en-in',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-ID',
                    alias: 'it-id',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-ID',
                    alias: 'en-id',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-JP',
                    alias: 'en-jp',
                    preferredCurrency: 'JPY',
                },
                {
                    id: 'it-JP',
                    alias: 'it-jp',
                    preferredCurrency: 'JPY',
                },
                {
                    id: 'ja-JP',
                    alias: 'ja-jp',
                    preferredCurrency: 'JPY',
                },
                {
                    id: 'en-MY',
                    alias: 'en-my',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-MY',
                    alias: 'it-my',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-MN',
                    alias: 'en-mn',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-MN',
                    alias: 'it-mn',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PH',
                    alias: 'en-ph',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PH',
                    alias: 'it-ph',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'ko-KR',
                    alias: 'ko-kr',
                    preferredCurrency: 'KRW',
                },
                {
                    id: 'en-KR',
                    alias: 'en-kr',
                    preferredCurrency: 'KRW',
                },
                {
                    id: 'it-KR',
                    alias: 'it-kr',
                    preferredCurrency: 'KRW',
                },
                {
                    id: 'en-TH',
                    alias: 'en-th',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-TH',
                    alias: 'it-th',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-VN',
                    alias: 'en-vn',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-VN',
                    alias: 'it-vn',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'ch-HK',
                    alias: 'ch-hk',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'ch-MO',
                    alias: 'ch-mo',
                    preferredCurrency: 'HKD',
                },
                {
                    id: 'ch-TW',
                    alias: 'ch-tw',
                    preferredCurrency: 'USD',
                },
            ],
        },
    },
    {
        id: 'bc-ru',
        l10n: {
            supportedCurrencies: ['EUR', 'RUB'],
            defaultCurrency: 'RUB',
            defaultLocale: 'ru-RU',
            supportedLocales: [
                {
                    id: 'ru-RU',
                    alias: 'ru-ru',
                    preferredCurrency: 'RUB',
                },
                {
                    id: 'en-RU',
                    alias: 'en-ru',
                    preferredCurrency: 'RUB',
                },
                {
                    id: 'it-RU',
                    alias: 'it-ru',
                    preferredCurrency: 'RUB',
                },
                {
                    id: 'ru-AM',
                    alias: 'ru-am',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-AM',
                    alias: 'en-am',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AM',
                    alias: 'it-am',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-AZ',
                    alias: 'ru-az',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-AZ',
                    alias: 'en-az',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AZ',
                    alias: 'it-az',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-BY',
                    alias: 'ru-by',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-BY',
                    alias: 'en-by',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-BY',
                    alias: 'it-by',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-GE',
                    alias: 'ru-ge',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GE',
                    alias: 'en-ge',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-GE',
                    alias: 'it-ge',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-KG',
                    alias: 'ru-kg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-KG',
                    alias: 'en-kg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-KG',
                    alias: 'it-kg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-UZ',
                    alias: 'ru-uz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-UZ',
                    alias: 'en-uz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-UZ',
                    alias: 'it-uz',
                    preferredCurrency: 'EUR',
                },
            ],
        },
    },
    {
        id: 'bc-international',
        l10n: {
            supportedCurrencies: ['AUD', 'GBP', 'USD', 'EUR'],
            defaultCurrency: 'AUD',
            defaultLocale: 'en-AU',
            supportedLocales: [
                {
                    id: 'en-AU',
                    alias: 'en-au',
                    preferredCurrency: 'AUD',
                },
                {
                    id: 'it-AU',
                    alias: 'it-au',
                    preferredCurrency: 'AUD',
                },
                {
                    id: 'en-AO',
                    alias: 'en-ao',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AO',
                    alias: 'it-ao',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-AI',
                    alias: 'en-ai',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-AI',
                    alias: 'it-ai',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-AR',
                    alias: 'en-ar',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-AR',
                    alias: 'it-ar',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-AR',
                    alias: 'es-ar',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-AW',
                    alias: 'en-aw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-AW',
                    alias: 'it-aw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-AW',
                    alias: 'es-aw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-BS',
                    alias: 'en-bs',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-BS',
                    alias: 'it-bs',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-BB',
                    alias: 'en-bb',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-BB',
                    alias: 'it-bb',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-VG',
                    alias: 'en-vg',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-VG',
                    alias: 'it-vg',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-CL',
                    alias: 'en-cl',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-CL',
                    alias: 'it-cl',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-CL',
                    alias: 'es-cl',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-CO',
                    alias: 'en-co',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-CO',
                    alias: 'it-co',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-CO',
                    alias: 'es-co',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-DM',
                    alias: 'en-dm',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-DM',
                    alias: 'it-dm',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-EG',
                    alias: 'en-eg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-EG',
                    alias: 'it-eg',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-FK',
                    alias: 'en-fk',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-FK',
                    alias: 'it-fk',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-FJ',
                    alias: 'en-fj',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-FJ',
                    alias: 'it-fj',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-GU',
                    alias: 'en-gu',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-GU',
                    alias: 'it-gu',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-HT',
                    alias: 'en-ht',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-HT',
                    alias: 'it-ht',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'fr-HT',
                    alias: 'fr-ht',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-IQ',
                    alias: 'en-iq',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-IQ',
                    alias: 'it-iq',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-IL',
                    alias: 'en-il',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-IL',
                    alias: 'it-il',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-JM',
                    alias: 'en-jm',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-JM',
                    alias: 'it-jm',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-JO',
                    alias: 'en-jo',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-JO',
                    alias: 'it-jo',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-KZ',
                    alias: 'en-kz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-KZ',
                    alias: 'it-kz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-KZ',
                    alias: 'ru-kz',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-KE',
                    alias: 'en-ke',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-KE',
                    alias: 'it-ke',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-KI',
                    alias: 'en-ki',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-KI',
                    alias: 'it-ki',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-LB',
                    alias: 'en-lb',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-LB',
                    alias: 'it-lb',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-MV',
                    alias: 'en-mv',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-MV',
                    alias: 'it-mv',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-MU',
                    alias: 'en-mu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-MU',
                    alias: 'it-mu',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-MS',
                    alias: 'en-ms',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-MS',
                    alias: 'it-ms',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'es-MS',
                    alias: 'es-ms',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-NP',
                    alias: 'en-np',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-NP',
                    alias: 'it-np',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-NC',
                    alias: 'en-nc',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-NC',
                    alias: 'it-nc',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'fr-NC',
                    alias: 'fr-nc',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-NZ',
                    alias: 'en-nz',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-NZ',
                    alias: 'it-nz',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-NG',
                    alias: 'en-ng',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-NG',
                    alias: 'it-ng',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-NU',
                    alias: 'en-nu',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-NU',
                    alias: 'it-nu',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-MK',
                    alias: 'en-mk',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-MK',
                    alias: 'it-mk',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-PW',
                    alias: 'en-pw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PW',
                    alias: 'it-pw',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PA',
                    alias: 'en-pa',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PA',
                    alias: 'it-pa',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-PA',
                    alias: 'es-pa',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PG',
                    alias: 'en-pg',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PG',
                    alias: 'it-pg',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PY',
                    alias: 'en-py',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PY',
                    alias: 'it-py',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-PY',
                    alias: 'es-py',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PE',
                    alias: 'en-pe',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PE',
                    alias: 'it-pe',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-PE',
                    alias: 'es-pe',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-PR',
                    alias: 'en-pr',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-PR',
                    alias: 'it-pr',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-PR',
                    alias: 'es-pr',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-WS',
                    alias: 'en-ws',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-WS',
                    alias: 'it-ws',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-SL',
                    alias: 'en-sl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SL',
                    alias: 'it-sl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SB',
                    alias: 'en-sb',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-SB',
                    alias: 'it-sb',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-ZA',
                    alias: 'en-za',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-ZA',
                    alias: 'it-za',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-ST',
                    alias: 'en-st',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-ST',
                    alias: 'it-st',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-ST',
                    alias: 'fr-st',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-TO',
                    alias: 'en-to',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-TO',
                    alias: 'it-to',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-TT',
                    alias: 'en-tt',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-TT',
                    alias: 'it-tt',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-TN',
                    alias: 'en-tn',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-TN',
                    alias: 'it-tn',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-TR',
                    alias: 'en-tr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-TR',
                    alias: 'it-tr',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-TM',
                    alias: 'en-tm',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-TM',
                    alias: 'it-tm',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'ru-TM',
                    alias: 'ru-tm',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-VI',
                    alias: 'en-vi',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-VI',
                    alias: 'it-vi',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-UY',
                    alias: 'en-uy',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-UY',
                    alias: 'it-uy',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-UY',
                    alias: 'es-uy',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-VE',
                    alias: 'en-ve',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-VE',
                    alias: 'it-ve',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'es-VE',
                    alias: 'es-ve',
                    preferredCurrency: 'USD',
                },
            ],
        },
    },
    {
        id: 'bc-cites',
        l10n: {
            supportedCurrencies: ['EUR', 'GBP', 'CHF'],
            defaultCurrency: 'EUR',
            defaultLocale: 'en-NO',
            supportedLocales: [
                {
                    id: 'en-NO',
                    alias: 'en-no',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-NO',
                    alias: 'it-no',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-AL',
                    alias: 'en-al',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AL',
                    alias: 'it-al',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-AD',
                    alias: 'en-ad',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AD',
                    alias: 'it-ad',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'es-AD',
                    alias: 'es-ad',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-BM',
                    alias: 'en-bm',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-BM',
                    alias: 'it-bm',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-BA',
                    alias: 'en-ba',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-BA',
                    alias: 'it-ba',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-FO',
                    alias: 'en-fo',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-FO',
                    alias: 'it-fo',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-TF',
                    alias: 'en-tf',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-TF',
                    alias: 'it-tf',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-TF',
                    alias: 'fr-tf',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GI',
                    alias: 'en-gi',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-GI',
                    alias: 'it-gi',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-GL',
                    alias: 'en-gl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-GL',
                    alias: 'it-gl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GD',
                    alias: 'en-gd',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-GD',
                    alias: 'it-gd',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-GD',
                    alias: 'fr-gd',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GP',
                    alias: 'en-gp',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-GP',
                    alias: 'it-gp',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-GP',
                    alias: 'fr-gp',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-GG',
                    alias: 'en-gg',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-GG',
                    alias: 'it-gg',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-IS',
                    alias: 'en-is',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-IS',
                    alias: 'it-is',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-IM',
                    alias: 'en-im',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-IM',
                    alias: 'it-im',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-JE',
                    alias: 'en-je',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-JE',
                    alias: 'it-je',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-LI',
                    alias: 'en-li',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'it-LI',
                    alias: 'it-li',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'de-LI',
                    alias: 'de-li',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'en-MQ',
                    alias: 'en-mq',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-MQ',
                    alias: 'it-mq',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-MQ',
                    alias: 'fr-mq',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-YT',
                    alias: 'en-yt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-YT',
                    alias: 'it-yt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-YT',
                    alias: 'fr-yt',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-ME',
                    alias: 'en-me',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-ME',
                    alias: 'it-me',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-RE',
                    alias: 'en-re',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-RE',
                    alias: 'it-re',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-RE',
                    alias: 'fr-re',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SM',
                    alias: 'en-sm',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SM',
                    alias: 'it-sm',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-RS',
                    alias: 'en-rs',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-RS',
                    alias: 'it-rs',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SC',
                    alias: 'en-sc',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'it-SC',
                    alias: 'it-sc',
                    preferredCurrency: 'GBP',
                },
                {
                    id: 'en-SX',
                    alias: 'en-sx',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SX',
                    alias: 'it-sx',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-SX',
                    alias: 'fr-sx',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-BL',
                    alias: 'en-bl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-BL',
                    alias: 'it-bl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'fr-BL',
                    alias: 'fr-bl',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-SJ',
                    alias: 'en-sj',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-SJ',
                    alias: 'it-sj',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'en-CH',
                    alias: 'en-ch',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'it-CH',
                    alias: 'it-ch',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'fr-CH',
                    alias: 'fr-ch',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'de-CH',
                    alias: 'de-ch',
                    preferredCurrency: 'CHF',
                },
                {
                    id: 'en-AX',
                    alias: 'en-ax',
                    preferredCurrency: 'EUR',
                },
                {
                    id: 'it-AX',
                    alias: 'it-ax',
                    preferredCurrency: 'EUR',
                },
            ],
        },
    },
    {
        id: 'bc-gcc',
        l10n: {
            supportedCurrencies: ['QAR', 'USD', 'SAR', 'AED', 'KWD'],
            defaultCurrency: 'USD',
            defaultLocale: 'en-BH',
            supportedLocales: [
                {
                    id: 'en-BH',
                    alias: 'en-bh',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-BH',
                    alias: 'it-bh',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-KW',
                    alias: 'en-kw',
                    preferredCurrency: 'KWD',
                },
                {
                    id: 'it-KW',
                    alias: 'it-kw',
                    preferredCurrency: 'KWD',
                },
                {
                    id: 'en-OM',
                    alias: 'en-om',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'it-OM',
                    alias: 'it-om',
                    preferredCurrency: 'USD',
                },
                {
                    id: 'en-QA',
                    alias: 'en-qa',
                    preferredCurrency: 'QAR',
                },
                {
                    id: 'it-QA',
                    alias: 'it-qa',
                    preferredCurrency: 'QAR',
                },
                {
                    id: 'en-SA',
                    alias: 'en-sa',
                    preferredCurrency: 'SAR',
                },
                {
                    id: 'it-SA',
                    alias: 'it-sa',
                    preferredCurrency: 'SAR',
                },
                {
                    id: 'en-AE',
                    alias: 'en-ae',
                    preferredCurrency: 'AED',
                },
                {
                    id: 'it-AE',
                    alias: 'it-ae',
                    preferredCurrency: 'AED',
                },
            ],
        },
    },
]
